import React from 'react'
import { Typography, Button } from '..'
import moment from 'moment';
import { LeftChevron } from '../../../theme/icons';
import propTypes from 'prop-types';

export const CalendarSelectWithArrows = ({ startDate = null, updateCalendarDate = () => null, }) => {
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    const handleChangeMonth = (type) => {
        const newDate = type === 'next' ? moment(startDate).add(1, 'M') : moment(startDate).subtract(1, 'M');
        updateCalendarDate(newDate)
    }

    return (
        <div className="ml-auto">
            <span className='flex items-center justify-center gap-2'>
                <Typography variant="base" className="font-semibold" text={moment(startDate)?.format("MMM YYYY")} />
                <div className='flex items-center gap-2'>
                    <Button variant="tertiary" onClick={() => handleChangeMonth("prev")} className="bg-white px-3 py-2" text="" icon={<LeftChevron />} />
                    <Button variant="tertiary"
                        disabled={String(currentYear) === String(moment(startDate)?.format('YYYY')) && String(currentMonth) === String(moment(startDate)?.format('MM'))}
                        onClick={() => handleChangeMonth("next")} className="rotate-180 bg-white px-3 py-2" text="" icon={<LeftChevron />} />
                </div>
            </span>
        </div>
    )
}

CalendarSelectWithArrows.propTypes = {
    startDate : propTypes.any,
    updateCalendarDate: propTypes.func
}
